import MediaService from "@/services/MediaService";
import ModuleCreator from "../ModuleCreator";

export const types = {
	FETCH: "media/fetch",
};
export const params = {};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.question,
 @property  {array}  modules.questions
 **/

const module = {
	state: {},
	mutations: {
	},
	getters: {},
	actions: {

	},
	types: types,
};
const Media = ModuleCreator("media", MediaService, module, types, params);
export default Media;
